import { AppAction, AppActions } from "./action";

import { IOdooSession } from "@juleb/browser";

export interface IAppState {
  odooSession: IOdooSession | undefined;
}

export const initialAppState: IAppState = {
  odooSession: undefined,
};

export const appReducer = (state: IAppState, action: AppAction) => {
  switch (action.type) {
    case AppActions.SET_ODOO_SESSION:
      return {
        odooSession: action.session,
      };
    default:
      return {
        ...state,
      };
  }
};
